import styled from 'styled-components'

const gap = 20
const gapSm = 15

export const Grid = styled.div`
  margin: ${gap}px 0;
  display: grid;
  grid-template-areas:
    'chrt assets'
    'chrt assets';
  grid-template-columns: minmax(320px, 1fr) 2.2fr;
  grid-template-rows: auto 1fr;
  grid-column-gap: ${gap}px;
  grid-row-gap: ${gap}px;

  ${({theme}) => theme.breakpoints.down('laptopM')} {
    grid-column-gap: ${gapSm}px;
    grid-row-gap: ${gapSm}px;
    margin: ${gapSm}px 0;
  }

  ${({theme}) => theme.breakpoints.down('tabletL')} {
    grid-template-columns: 1fr 1fr;
    grid-template-areas:
      'chrt chrt'
      'assets assets';
  }

  ${({theme}) => theme.breakpoints.down('tablet')} {
    grid-template-columns: 100%;
    grid-template-areas:
      'chrt'
      'assets';
  }
`
export const CellChart = styled.div`
  grid-area: chrt;
`

export const CellAssets = styled.div(() => ({
  gridArea: 'assets',
  display: 'flex',
  flexDirection: 'column',
}))
